import * as yup from 'yup'

export const easypostWebhookSchema = yup.object({
  description: yup.string().required(),
  mode: yup.string().notRequired(),
  previous_attributes: yup
    .object({
      status: yup.string().notRequired(),
    })
    .notRequired(),
  created_at: yup.string().notRequired(),
  pending_urls: yup.array().of(yup.string().url()).notRequired(),
  completed_urls: yup.array().of(yup.string().url()).notRequired(),
  updated_at: yup.string().notRequired(),
  id: yup.string().required(),
  user_id: yup.string().required(),
  status: yup.string().required(),
  object: yup.string().notRequired(),
  result: yup
    .object({
      id: yup.string().notRequired(),
      object: yup.string().notRequired(),
      mode: yup.string().notRequired(),
      tracking_code: yup.string().notRequired(),
      status: yup.string().notRequired(),
      status_detail: yup.string().notRequired(),
      created_at: yup.string().notRequired(),
      updated_at: yup.string().notRequired(),
      signed_by: yup.string().notRequired(),
      weight: yup.number().notRequired(),
      est_delivery_date: yup.string().notRequired(),
      shipment_id: yup.string().notRequired(),
      carrier: yup.string().notRequired(),
      tracking_details: yup
        .array()
        .of(
          yup.object({
            object: yup.string().notRequired(),
            message: yup.string().notRequired(),
            description: yup.string().notRequired(),
            status: yup.string().notRequired(),
            status_detail: yup.string().notRequired(),
            datetime: yup.string().notRequired(),
            source: yup.string().notRequired(),
            carrier_code: yup.string().notRequired(),
            tracking_location: yup
              .object({
                object: yup.string().notRequired(),
                city: yup.string().notRequired(),
                state: yup.string().notRequired(),
                country: yup.string().notRequired(),
                zip: yup.string().notRequired(),
              })
              .notRequired(),
            est_delivery_date: yup.string().notRequired(),
          }),
        )
        .notRequired(),
      fees: yup.array().of(yup.object()).notRequired(),
      carrier_detail: yup
        .object({
          object: yup.string().notRequired(),
          service: yup.string().notRequired(),
          container_type: yup.string().notRequired(),
          est_delivery_date_local: yup.string().notRequired(),
          est_delivery_time_local: yup.string().notRequired(),
          origin_location: yup.string().notRequired(),
          origin_tracking_location: yup
            .object({
              object: yup.string().notRequired(),
              city: yup.string().notRequired(),
              state: yup.string().notRequired(),
              country: yup.string().notRequired(),
              zip: yup.string().notRequired(),
            })
            .notRequired(),
          destination_location: yup.string().notRequired(),
          destination_tracking_location: yup
            .object({
              object: yup.string().notRequired(),
              city: yup.string().notRequired(),
              state: yup.string().notRequired(),
              country: yup.string().notRequired(),
              zip: yup.string().notRequired(),
            })
            .notRequired(),
          guaranteed_delivery_date: yup.string().notRequired(),
          alternate_identifier: yup.string().notRequired(),
          initial_delivery_attempt: yup.string().notRequired(),
        })
        .notRequired(),
      public_url: yup.string().url().notRequired(),
    })
    .required(),
})
